import React, { useEffect, useMemo, useState } from 'react';
import { Button, Split, SplitItem, GalleryItem } from '@patternfly/react-core';
import _ from 'lodash';
import { useTranslation } from 'localization/useTranslation';
import DescriptionCard, { DescriptionCardSkeleton } from 'components/DescriptionCard/DescriptionCard';
import useAPI from 'services/useAPI';
import { v4 } from 'uuid';
import { useMutation } from '@tanstack/react-query';


const AssetCard = ({ assetInfo, isLoading = false, hasEdit = false, updateAssetInfo }) => {
  const api = useAPI();
  const T = useTranslation();
  const [asset, setAsset] = useState({});
  const [key, setKey] = useState(v4());
  const assetModels = [
    { label: T.common.assetId, path: 'id' },
    { label: T.common.displayname, path: 'displayName', key, editType: (hasEdit) ? 'inline' : undefined },
    { label: T.common.model, path: 'model.displayName' },
    { label: T.common.modelId, path: 'model.id' },
    { label: T.common.description, path: 'description', key, editType: hasEdit ? 'inline' : undefined }
  ];

  useEffect(function updateAssetInfo() {
    setAsset(assetInfo);
  }, [assetInfo]);

  const assetMutation = useMutation({
    mutationFn: (updatedAsset) => {
      return api.core.updateAsset(null, assetInfo.id, updatedAsset);
    },
    onSuccess: updateAssetInfo()
  });

  const cardFooter = useMemo(() => {
    const a1 = _.pick(asset, ['displayName', 'description']);
    const a2 = _.pick(assetInfo, ['displayName', 'description']);
    if (!_.isEqual(a1, a2)) {
      return (
        <Split hasGutter>
          <SplitItem><Button
            isLoading={assetMutation.isPending}
            onClick={() => {
              assetMutation.mutate(_.pick(asset, ['displayName', 'description']));
            }}>{ T.common.update }</Button>
          </SplitItem>
          <SplitItem><Button onClick={() => {
            setAsset({ ...assetInfo });
            setKey(v4());
          }}>{ T.common.cancel }</Button>
          </SplitItem>
        </Split>
      );
    }
    return null;
  }, [T.common.cancel, T.common.update, asset, assetInfo, assetMutation]);

  return (
    <GalleryItem>
      { isLoading && <DescriptionCardSkeleton /> }
      { !isLoading &&
        <DescriptionCard
          models={assetModels}
          item={asset} setItem={setAsset}
          heading={T.common.asset}
          isLoading={isLoading}
          footer={cardFooter}
        />
      }
    </GalleryItem>
  );

};

export default AssetCard;
